/**
 * Hook para obtener información del usuario.
 */
import type { UserDto } from "common/models";
import { useQuery, UseQueryResult } from "react-query";
import type { UseQueryOptions } from "react-query";
import { config } from "common/config";
import { Queries } from "ui/query/queries";
import { usersApi } from "../api/usersApi";

export function useGetUserInfo<TData = UserDto>(
    options?: Omit<UseQueryOptions<UserDto, unknown, TData>, "queryKey" | "queryFn">
): UseQueryResult<TData> {
    const organizationAddress = config.organization.address;
    return useQuery<UserDto, unknown, TData>(
        [Queries.USER_INFO, organizationAddress],
        async () => {
            const { data } = await usersApi.info(organizationAddress);
            return data;
        },
        { refetchInterval: 30000, ...options }
    );
}
